/** @format */

import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import React, { memo, useMemo } from 'react';
import styled from 'styled-components';

interface PropsDescription {
  children: string;
}

const RoomDescription: React.FC<PropsDescription> = memo(({ children }) => {
  const { t } = useAppTranslation();

  const capitalizeFirstLetter = (string: string): string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const splitPoint = useMemo(() => t('pdp.flatshare_can_be_found' as TTranslation), [t]);
  const splitTitle = useMemo(() => <h2>{t('pdp.flatshare' as TTranslation)}</h2>, [t]);

  const splitContent = useMemo(() => {
    const index = children.indexOf(splitPoint);
    if (index !== -1) {
      const part1 = children.substring(0, index).trim();
      const part3 = capitalizeFirstLetter(children.substring(index).trimStart());
      return {
        part1: part1,
        part2: splitTitle,
        part3: part3,
      };
    } else {
      return {
        part1: children,
        part2: '',
        part3: '',
      };
    }
  }, [children, splitPoint, splitTitle]);

  return (
    <RoomInfoDescription>
      <p>{splitContent.part1}</p>
      {splitContent.part2 && splitContent.part2}
      {splitContent.part3 && <p>{splitContent.part3}</p>}
    </RoomInfoDescription>
  );
});

const RoomInfoDescription = styled.div`
  h2 {
    margin-block: 1.875rem 0.75rem;
    font-size: clamp(1.125rem, 1.0417rem + 0.3704vw, 1.375rem);
    letter-spacing: clamp(0.0225rem, 0.0208rem + 0.0074vw, 0.0275rem);
    color: rgb(1, 89, 98);
  }
  p {
    color: ${({ theme }) => theme.colors.joivy.black};
    font-size: clamp(1rem, 0.9583rem + 0.1852vw, 1.125rem);
    line-height: clamp(1.375rem, 1.3333rem + 0.1852vw, 1.5rem);
    letter-spacing: clamp(0.03rem, 0.0287rem + 0.0056vw, 0.03375rem);
    margin: 0;
  }
`;

export default RoomDescription;
